import { create } from "zustand";

interface CampaignNotebookState {
  openCampaignId: string | null;
  open: (campaignId: string) => void;
  close: () => void;
}

export const useCampaignNotebookStore = create<CampaignNotebookState>((set) => ({
  openCampaignId: null,
  open: (campaignId) => set({ openCampaignId: campaignId }),
  close: () => set({ openCampaignId: null }),
}));
